module.exports = __webpack_public_path__ + "static/noise-11a3409747a3258128c5c8968a13a868.png";